import type { WritingTask } from '../types';
import { coursePlanLessons } from './coursePlan';

const writingPrompt = {
  Beginner: (title: string) => `Write 3 simple sentences about ${title.toLowerCase()}.`,
  A1: (title: string) => `Write a short message or dialogue about ${title.toLowerCase()}.`,
  A2: (title: string) => `Write a short email or paragraph about ${title.toLowerCase()}.`,
  B1: (title: string) => `Write one organised paragraph or short story about ${title.toLowerCase()}.`,
  B2: (title: string) => `Write an opinion essay paragraph about ${title.toLowerCase()} with a counterargument.`,
  C1: (title: string) => `Write a formal academic paragraph about ${title.toLowerCase()} with hedging and synthesis.`,
} as const;

const structure = {
  Beginner: ['Sentence 1: person or thing', 'Sentence 2: simple detail', 'Sentence 3: feeling or action'],
  A1: ['Greeting or first sentence', 'Main message', 'Question or closing'],
  A2: ['Opening sentence', 'Situation or plan', 'Reason or problem', 'Closing sentence'],
  B1: ['Topic sentence', 'Reason', 'Example', 'Final sentence'],
  B2: ['Clear position', 'Supporting argument', 'Counterargument', 'Balanced conclusion'],
  C1: ['Qualified claim', 'Evidence or synthesis', 'Limitation', 'Implication'],
} as const;

export const writingTasks: WritingTask[] = coursePlanLessons.map((lesson) => ({
  id: `w-${lesson.id}`,
  level: lesson.level,
  title: lesson.title,
  prompt: writingPrompt[lesson.level](lesson.title),
  usefulVocabulary: [lesson.category, lesson.grammarFocus, lesson.example.en],
  structure: [...structure[lesson.level]],
  modelAnswer: lesson.level === 'Beginner' || lesson.level === 'A1'
    ? `${lesson.example.en} I can write this clearly.`
    : `${lesson.example.en} This example can be developed with a reason, evidence and a final reflection.`,
  checklist: lesson.level === 'B2' || lesson.level === 'C1'
    ? ['I made a precise claim', 'I used advanced linking', 'I included a limitation or counterargument', 'My style matches the task']
    : ['I answered the prompt', 'I used lesson vocabulary', 'My sentences are complete', 'I checked spelling and grammar'],
}));
